export const locale = {
    lang: "en-US",
    data: {
        TERMS_OF_USE: {
            TITLE: "Terms of Use",
            DEFAULT: "Error retrieving terms of use.",
            SUBMIT_ERROR: "Error on request terms of use.",
            BUTTON_LABEL: "Close"
        }
    }
};
